'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

/** UserLink model */


/** Exported types */
var UserLink = (0, _immutable.Record)({
    title: '',
    url: '',
    target: '',
    className: '',
    displayRule: '',
    isPending: false,
    isEligible: true
});

/**
 * Converts a single userLink to a data model
 * @param {PlatformType} platform The platform to get the userLinks for
 * @returns {function(UserLinkListType, SquizUserLinkType)} A function which adds the passed userLink
 * to the accumulator list
 */

var userLinkToDataModel = function userLinkToDataModel(platform) {
    return function (bag, userLink) {
        var _userLink$link$platfo = userLink.link[platform],
            url = _userLink$link$platfo.url,
            target = _userLink$link$platfo.target,
            enabled = _userLink$link$platfo.enabled;
        var title = userLink.title,
            className = userLink.className,
            displayRule = userLink.displayRule;


        if (enabled) {
            if (displayRule !== '') {
                return bag.push(new UserLink({
                    title: title,
                    className: className,
                    url: url,
                    target: target,
                    displayRule: displayRule,
                    isPending: true,
                    isEligible: false
                }));
            }
            return bag.push(new UserLink({
                title: title,
                className: className,
                url: url,
                target: target,
                displayRule: displayRule,
                isEligible: true
            }));
        }
        return bag;
    };
};

/**
 * Wrapper function to get platform parameter in scope
 * @param {Array<SquizUserLinkType>} userLinks An array of userLinks as returnd by Squiz
 * @param {PlatformType} platform The platform that was requested
 * @returns {UserLinkListType} An immutable list of UserLink Records
 */
var transformUserLinkData = function transformUserLinkData(userLinks) {
    var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mobile';

    if (userLinks.data) {
        return userLinks.data.reduce(userLinkToDataModel(platform), (0, _immutable.List)());
    }
    return (0, _immutable.List)();
};

exports.default = transformUserLinkData;
//# sourceMappingURL=model.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/user-links/model.js
// module id = 259
// module chunks = 0